<template>
  <div class="page flex-col">
    <StudentHeader title="学习表现报告" />

    <div class="box_2 flex-col">
      <div class="image-wrapper_1 flex-row">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGbd2a4bb0c440910c25e09bd8f1da1d7c.png"
        />
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG0489e01ec0080a2047299f54ecb6972e.png"
        />
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGc90753ade23ec5f9d5cf8372a73363f3.png"
        />
      </div>
      <div class="text-wrapper_1 flex-row">
        <span class="text_3"></span>
        <span class="text_4"></span>
        <span class="text_5"></span>
      </div>
      <div class="section_1 flex-col">
        <div class="block_1 flex-row justify-between">
          <div class="section_2 flex-col justify-end">
            <div class="group_1 flex-row justify-between">
              <span class="text_6">所有单元</span>
              <img
                class="thumbnail_1"
                referrerpolicy="no-referrer"
                src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGa7e3954ad9f1ed3c78e67b7e1ca8bfc9.png"
              />
            </div>
            <div class="group_2 flex-col"></div>
          </div>
          <div class="section_3 flex-col justify-end">
            <div class="block_2 flex-row justify-between">
              <span class="text_7">概观</span>
              <img
                class="thumbnail_2"
                referrerpolicy="no-referrer"
                src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGa7e3954ad9f1ed3c78e67b7e1ca8bfc9.png"
              />
            </div>
            <div class="block_3 flex-col"></div>
          </div>
        </div>
        <div class="block_4 flex-row justify-between">
          <div class="block_5 flex-col">
            <span class="text_8">完成度</span> <span class="text_9">25%</span>
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG5d52d90806417dd3a7dd44f0fa30fcac.png"
            />
          </div>
          <div class="text-wrapper_2 flex-col">
            <span class="text_10">尝试次数</span>
            <span class="text_11">3次</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue"
import { useRoute, useRouter } from "vue-router"

import StudentHeader from "@/components/StudentHeader.vue"

const router = useRouter()
const route = useRoute()

const title = ref("课程")
const idx = ref(0)
</script>
<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: 100vw;
  overflow: hidden;
}

.box_1 {
  width: 100vw;
  height: 3.86vw;
  background: url(https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG731f49365833a996cb875308a50143fb.png)
    100% no-repeat;
  background-size: 100% 100%;
}

.label_1 {
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.57vw 0 0 0.46vw;
  cursor: pointer;
}

.label_2 {
  width: 2.09vw;
  height: 2.09vw;
  margin: 0.57vw 0 0 1.04vw;
}

.text_1 {
  width: 3.75vw;
  height: 1.57vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 0.83vw 0 0 0.83vw;
}

.label_3 {
  width: 1.57vw;
  height: 1.98vw;
  margin: 0.78vw 0 0 33.75vw;
}

.text_2 {
  width: 10vw;
  height: 2.19vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.66vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.67vw 0 0 0.98vw;
}

.label_4 {
  width: 2.5vw;
  height: 2.5vw;
  margin: 0.62vw 2.03vw 0 38.9vw;
}

.box_2 {
  width: 100vw;
  height: 52.45vw;
  margin-bottom: 0.06vw;
}

.image-wrapper_1 {
  width: 64.22vw;
  height: 11.93vw;
  margin: 4.06vw 0 0 17.86vw;
}

.image_1 {
  width: 19.38vw;
  height: 11.93vw;
}

.image_2 {
  width: 19.38vw;
  height: 11.93vw;
  margin-left: 3.65vw;
}

.image_3 {
  width: 19.38vw;
  height: 11.93vw;
  margin-left: 2.45vw;
}

.text-wrapper_1 {
  width: 64.22vw;
  height: 1.36vw;
  margin: 1.14vw 0 0 17.86vw;
}

.text_3 {
  width: 19.38vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.05vw;
}

.text_4 {
  width: 19.38vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 3.65vw;
}

.text_5 {
  width: 19.38vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-left: 2.45vw;
}

.section_1 {
  background-color: rgba(239, 245, 248, 1);
  border-radius: 31px;
  width: 52.24vw;
  height: 30.16vw;
  margin: 1.61vw 0 2.18vw 23.85vw;
}

.block_1 {
  width: 32.82vw;
  height: 1.67vw;
  margin: 1.56vw 0 0 9.16vw;
}

.section_2 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  width: 19.74vw;
  height: 1.67vw;
  border: 1px solid rgba(209, 209, 209, 1);
}

.group_1 {
  width: 18.6vw;
  height: 1.1vw;
  margin: 0.26vw 0 0 0.62vw;
}

.text_6 {
  width: 2.92vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.72vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.thumbnail_1 {
  width: 1.05vw;
  height: 1.05vw;
  margin-top: 0.06vw;
}

.group_2 {
  background-color: rgba(97, 97, 97, 1);
  width: 19.74vw;
  height: 0.06vw;
  margin-top: 0.27vw;
}

.section_3 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  width: 10.68vw;
  height: 1.67vw;
  border: 1px solid rgba(209, 209, 209, 1);
}

.block_2 {
  width: 9.54vw;
  height: 1.1vw;
  margin: 0.26vw 0 0 0.62vw;
}

.text_7 {
  width: 1.46vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(112, 112, 112, 1);
  font-size: 0.72vw;
  font-family: Segoe UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.thumbnail_2 {
  width: 1.05vw;
  height: 1.05vw;
  margin-top: 0.06vw;
}

.block_3 {
  background-color: rgba(97, 97, 97, 1);
  width: 10.68vw;
  height: 0.06vw;
  margin-top: 0.27vw;
}

.block_4 {
  width: 32.82vw;
  height: 18.49vw;
  margin: 4.89vw 0 3.54vw 9.16vw;
}

.block_5 {
  box-shadow: 2px 2px 6px 3px rgba(12, 12, 13, 0.05);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 26px;
  position: relative;
  width: 15.21vw;
  height: 18.49vw;
}

.text_8 {
  width: 3.75vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 1.3vw 0 0 5.72vw;
}

.text_9 {
  width: 4.48vw;
  height: 2.5vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.87vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.88vw;
  margin: 6.09vw 0 6.92vw 5.36vw;
}

.image_4 {
  position: absolute;
  left: 2.14vw;
  top: 4.95vw;
  width: 10.94vw;
  height: 10.94vw;
}

.text-wrapper_2 {
  box-shadow: 2px 2px 6px 3px rgba(12, 12, 13, 0.05);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 26px;
  width: 15.21vw;
  height: 18.49vw;
}

.text_10 {
  width: 5vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 1.3vw 0 0 5.1vw;
}

.text_11 {
  width: 10.94vw;
  height: 2.5vw;
  overflow-wrap: break-word;
  color: rgba(55, 91, 165, 1);
  font-size: 1.87vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.88vw;
  margin: 5.93vw 0 7.08vw 2.13vw;
}
</style>
